export default "__VITE_ASSET__6a6d7cb9__"